import { useRef } from 'react';

import MaskedNumberInput, { MaskedNumberInputProps } from 'components/masked-number-input';

import { toReadablePrice } from 'lib/utils';
import { numberWithNounMask } from 'lib/input-masks';

type YearInputProps = MaskedNumberInputProps;

const YearInput: React.FC<YearInputProps> = (props) => {
  const { min = 1, max = 30, ...rest } = props;

  const maskOpts = useRef(numberWithNounMask('год', 'лет', 'года', { min, max }));

  return (
    <MaskedNumberInput
      min={min}
      max={max}
      format={toReadablePrice}
      maskOpts={maskOpts.current}
      {...rest}
      placeholder='1 год'
    />
  );
};

export default YearInput;
